var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"question"},[_vm._v("Choose Your Move")]),_c('option-component'),_c('score-header-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }